import React from "react";
import PropTypes from "prop-types";
import Paginator from "theme/components/molecules/Paginator";
import { LayerRelated } from "theme/modules/Layer/LayerRelated";

const PaginatedList = (props) => {
  if (!props.showPaginated) {
    return props.children;
  }

  const pagination = props.lastPage > 1 && (
    <Paginator
      maxPage={props.lastPage}
      page={props.page}
      location={props.location}
    />
  );

  // The MediaQuery not matching component is a hack
  // Without it, React lose its mind and break the DOM
  // We will use this temporary while waiting for a proper fix.
  return (
    <div className="paginated">
      <div className="paginated__body">
        <LayerRelated
          activeFilters={props.activeFilters}
          toggleFilters={props.toggleFilters}
          layer={props.layer}
          location={props.location}
          isLayerActive={props.isLayerActive}
        />
        <div className="paginated__body__list">
          <div className="head-sort-limit">
            {props.renderSorting && props.renderSorting()}
            {props.renderLimit && props.renderLimit()}
          </div>
          {props.children}
        </div>
      </div>
      {pagination}
    </div>
  );
};

PaginatedList.propTypes = {
  ...LayerRelated.propTypes,
  location: PropTypes.object,
  lastPage: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  renderSorting: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  renderLimit: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
};

export default PaginatedList;
